import type { ReactNode } from 'react';
import { Center, Loader } from '@mantine/core';
import { Navigate } from 'react-router-dom';
import { useAppsList } from '../queries/apps';
import { useAuthStore } from '../auth/auth-store';

/**
 * Renders children only when the current user has access to the given app
 * (or is a superadmin). Otherwise redirects to `/`. Mirrors RequireProject.
 */
export function RequireApp({ appKey, children }: { appKey: string; children: ReactNode }) {
  const { data: apps, isLoading } = useAppsList();
  const systemRole = useAuthStore((s) => s.user?.system_role);

  if (isLoading) {
    return (
      <Center h="60vh">
        <Loader />
      </Center>
    );
  }

  const hasAccess = systemRole === 'superadmin' || (apps ?? []).some((a) => a.key === appKey);
  if (!hasAccess) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
